import { mapActions, mapGetters } from "vuex"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import { goToNextTab } from "@/utils/navigationUtils"

// Helper pour toutes les pages des formulaires inscriptions.
export default {
  mixins: [NavigationPageFormulaireMixin],
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      autorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
    }),
  },
  async created () {
    if (this.demandeInscriptionId) {
      await this.fetchAutorisationDePratiqueByDemandeInscriptionId(this.demandeInscriptionId)
    }
  },
  methods: {
    ...mapActions({
      fetchAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
    }),
    next () {
      goToNextTab(this.$route, this.$router, this.autorisations)
    },
    back () {
      goToNextTab(this.$route, this.$router, this.autorisations, true)
    },
  },
}
